/**
 * Simple mega-menu panel hover logic (extracted from
 * snippets/mega-menu-list.liquid for deferred loading — backend audit L03).
 *
 * Keeps the panel open while the cursor crosses the gap between the trigger
 * row and the panel (300ms grace), complementing the pure-CSS :has(:hover)
 * rules in custom.css.
 *
 * Uses document-level event delegation on purpose: the header menu is
 * re-rendered through the Section Rendering API after the initial lightweight
 * render (see the eager_loading note in mega-menu-list.liquid), which replaces
 * the menu's DOM nodes. Listeners bound to those nodes — or deferred behind a
 * one-shot DOMContentLoaded — would silently die on that refresh. Delegation
 * binds once to `document` and keeps working no matter how often the menu
 * markup is swapped.
 */
(function () {
  if (window.__megaMenuPanelInit) return;
  window.__megaMenuPanelInit = true;

  var hideTimers = new WeakMap();

  /* The .mega-menu__list--simple that owns a hovered trigger row or panel,
     or null when the event target is outside both. */
  function listFor(target) {
    if (!target || typeof target.closest !== 'function') return null;
    var hot = target.closest('.mega-menu__simple-row--trigger, .mega-menu__simple-panel');
    if (!hot) return null;
    return hot.closest('.mega-menu__list--simple');
  }

  document.addEventListener('mouseover', function (e) {
    var list = listFor(e.target);
    if (!list) return;
    clearTimeout(hideTimers.get(list));
    list.classList.add('mega-menu--panel-active');
  });

  document.addEventListener('mouseout', function (e) {
    var list = listFor(e.target);
    if (!list) return;
    /* Still inside the same list's trigger/panel? Not a real exit. */
    if (listFor(e.relatedTarget) === list) return;
    clearTimeout(hideTimers.get(list));
    hideTimers.set(
      list,
      setTimeout(function () {
        list.classList.remove('mega-menu--panel-active');
      }, 300)
    );
  });
})();
